import { render, staticRenderFns } from "./shanghu.vue?vue&type=template&id=303f6160&"
import script from "./shanghu.vue?vue&type=script&lang=js&"
export * from "./shanghu.vue?vue&type=script&lang=js&"
import style0 from "./shanghu.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports